import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/RegningenKundeopplevelse.jpeg";

function RegningenKundeopplevelse() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.energyBillExperience.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.energyBillExperience.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/nar-regningen-blir-del-av-kundeopplevelsen"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.energyBillExperience.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.energyBillExperience.sections.intro.content")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.energyBillExperience.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5">
          <img
            src={article_img}
            className="w-full"
            alt={i18next.t("pages.articles.list.energyBillExperience.imageAlt")}
          />
          <p className="text-sm text-secondary mt-2">
            {i18next.t("pages.articles.credit.photoBy")}{" "}
            <a
              href="https://unsplash.com/@matthewhenry?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Matthew Henry
            </a>{" "}
            {i18next.t("pages.articles.credit.from")}{" "}
            <a
              href="https://unsplash.com/photos/photo-of-truss-towers-yETqkLnhsUI?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Unsplash
            </a>
          </p>
        </div>
        
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.energyBillExperience.sections.moreThanNumbers.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.energyBillExperience.sections.moreThanNumbers.content")}</p>
            <p>
              {i18next.t("pages.articles.list.energyBillExperience.sections.eaa.content1")}
              <a href="/artikler/tilgjengelighetsdirektivet" className=" underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.energyBillExperience.sections.eaa.link")}
              </a>
              {i18next.t("pages.articles.list.energyBillExperience.sections.eaa.content2")}
            </p>
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.energyBillExperience.sections.fromDuty.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.energyBillExperience.sections.fromDuty.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.energyBillExperience.sections.fromDuty.content2")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.energyBillExperience.sections.xper.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.energyBillExperience.sections.xper.content1")}
              <a href="/docengine" className=" underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.energyBillExperience.sections.xper.link")}
              </a>
              {i18next.t("pages.articles.list.energyBillExperience.sections.xper.content2")}
            </p>
            <p>{i18next.t("pages.articles.list.energyBillExperience.sections.xper.content3")}</p>

         </div>
        </div>
      </div>
    </div>
  );
}

export default RegningenKundeopplevelse;



